var map = {
	"../pages/article-detail/article-detail.module": [
		790,
		22
	],
	"../pages/article/article.module": [
		749,
		21
	],
	"../pages/body-photo/body-photo.module": [
		750,
		32
	],
	"../pages/category/category.module": [
		751,
		52
	],
	"../pages/comments/comments.module": [
		798,
		3
	],
	"../pages/customer-service/customer-service.module": [
		752,
		51
	],
	"../pages/discover-detail/discover-detail.module": [
		789,
		20
	],
	"../pages/discover/discover.module": [
		799,
		19
	],
	"../pages/dynamic/dynamic.module": [
		753,
		50
	],
	"../pages/image-editor/image-editor.module": [
		756,
		33
	],
	"../pages/interest/interest.module": [
		755,
		49
	],
	"../pages/lottery-record/lottery-record.module": [
		754,
		18
	],
	"../pages/lottery-sale/lottery-sale.module": [
		757,
		17
	],
	"../pages/notice/notice.module": [
		791,
		2
	],
	"../pages/order-detail/order-detail.module": [
		759,
		30
	],
	"../pages/order-qrcode/order-qrcode.module": [
		758,
		29
	],
	"../pages/popup-filter/filter.module": [
		761,
		48
	],
	"../pages/popup-share/popup-share.module": [
		760,
		47
	],
	"../pages/post-notes/post-notes.module": [
		762,
		31
	],
	"../pages/profile/profile.module": [
		797,
		16
	],
	"../pages/recommend/recommend.module": [
		763,
		46
	],
	"../pages/social-list/social-list.module": [
		765,
		45
	],
	"../pages/vd-area/area.module": [
		764,
		44
	],
	"../pages/vd-brandsale/brandsale.module": [
		792,
		15
	],
	"../pages/vd-carts/carts.module": [
		766,
		28
	],
	"../pages/vd-common-modal/common-modal.module": [
		767,
		14
	],
	"../pages/vd-consignee/consignee.module": [
		769,
		13
	],
	"../pages/vd-coupons/coupons.module": [
		768,
		27
	],
	"../pages/vd-delivered/delivered.module": [
		770,
		26
	],
	"../pages/vd-home/home.module": [
		800,
		1
	],
	"../pages/vd-image-show/image-show.module": [
		772,
		0
	],
	"../pages/vd-login/login.module": [
		771,
		43
	],
	"../pages/vd-lottery/lottery.module": [
		773,
		42
	],
	"../pages/vd-menu/menu.module": [
		774,
		41
	],
	"../pages/vd-movesale/movesale.module": [
		775,
		12
	],
	"../pages/vd-moveshop/moveshop.module": [
		776,
		11
	],
	"../pages/vd-my/my.module": [
		794,
		40
	],
	"../pages/vd-orders/orders.module": [
		793,
		25
	],
	"../pages/vd-pass/pass.module": [
		778,
		39
	],
	"../pages/vd-pay/pay.module": [
		795,
		24
	],
	"../pages/vd-popup/popup.module": [
		777,
		10
	],
	"../pages/vd-sale-detail/sale-detail.module": [
		801,
		9
	],
	"../pages/vd-score/score.module": [
		779,
		23
	],
	"../pages/vd-search/search.module": [
		780,
		8
	],
	"../pages/vd-setting/setting.module": [
		796,
		38
	],
	"../pages/vd-signup/signup.module": [
		781,
		7
	],
	"../pages/vd-sku/sku.module": [
		783,
		6
	],
	"../pages/vd-tabs/tabs.module": [
		784,
		37
	],
	"../pages/vd-tagsale/tagsale.module": [
		782,
		5
	],
	"../pages/vd-tutorial/tutorial.module": [
		785,
		36
	],
	"../pages/vd-welcome/welcome.module": [
		786,
		35
	],
	"../pages/vip/vip.module": [
		787,
		34
	],
	"../pages/zan/zan.module": [
		788,
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 254;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 254
// module chunks = 53